'use client';

import React, { useEffect, useRef } from 'react';
import Icon from '@/components/ui/AppIcon';

export default function BackToTop() {
  const btnRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const toggle = () => {
      if (!btnRef?.current) return;
      if (window.scrollY > 400) {
        btnRef?.current?.classList?.add('visible');
      } else {
        btnRef?.current?.classList?.remove('visible');
      }
    };
    window.addEventListener('scroll', toggle, { passive: true });
    return () => window.removeEventListener('scroll', toggle);
  }, []);

  return (
    <button data-component-id="src/app/components/BackToTop.tsx:23:4" data-component-path="src/app/components/BackToTop.tsx" data-component-line="23" data-component-end-line="30" data-component-file="BackToTop.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22back-to-top%22%7D"
      ref={btnRef}
      className="back-to-top"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="Back to top"
    >
      <Icon data-component-id="src/app/components/BackToTop.tsx:29:6" data-component-path="src/app/components/BackToTop.tsx" data-component-line="29" data-component-end-line="29" data-component-file="BackToTop.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22ArrowUpIcon%22%2C%22className%22%3A%22text-white%22%7D" name="ArrowUpIcon" size={18} className="text-white" />
    </button>
  );
}